"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
const _excluded = ["className"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const iconStyles = (0, _styledComponents.css)`
    position: relative;
    display: inline-block;
    border: 0;
    font-size: ${({
  size
}) => {
  switch (size) {
    case 'md':
      return '32px;';
    case 'sm':
      return '16px;';
    default:
      return size;
  }
}};
    color: ${({
  color
}) => color};
    fill: ${({
  color
}) => color};
`;
const badgeStyles = (0, _styledComponents.css)`
    position: absolute;
    top: 0;
    right: -8px;

    padding: 1px;
    color: var(--bg-color);
    background-color: ${({
  color
}) => color || 'var(--text-primary-color)'};
    
    border-radius: 50%;
    border: 2px solid var(--bg-color);
`;
const StyledIcon = _styledComponents.default.i`
    ${iconStyles};
    ${({
  badge
}) => badge && badgeStyles};
`;

/**
 * In order to use icons, the hosting app should have the icons .css imported:
 * import '@vectorworks/vcs-ui/node_modules/@vectorworks/vcs-icons/style.css';
 */
const Icon = _ref => {
  let {
      className = ''
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const fullIconName = 'icon-' + props.icon;
  const cssClass = `${fullIconName} ${className}`;
  return /*#__PURE__*/_react.default.createElement(StyledIcon, _extends({
    className: cssClass,
    role: "img",
    "aria-label": fullIconName
  }, props), props.children);
};
exports.Icon = Icon;
Icon.defaultProps = {
  size: 'md',
  badge: false,
  className: ''
};
Icon.propTypes = {
  icon: _propTypes.default.string.isRequired,
  size: _propTypes.default.string,
  className: _propTypes.default.string,
  color: _propTypes.default.string,
  badge: _propTypes.default.bool
};

// What if the icon is in a selected item? How do we color it?